import './App.css';
import { RecoilRoot } from 'recoil'
import Rotas from './rotas';
import { ConfigProvider } from 'antd'

import { ToastProvider } from 'react-toast-notifications';

function App() {
  return (<ToastProvider>
    <RecoilRoot>
      <ConfigProvider
        theme={{
          token: {
            // Seed Token, affects wide range
            colorPrimary: '#1a365c'
          },
        }}
      >
        <Rotas />
      </ConfigProvider>
    </RecoilRoot>
  </ToastProvider>

  );
}



export default App;
